export const getCMSMenuLocations = (state) => {
  const data = state.cms.menuLocations.menuLocations;
  if (data) {
    return data;
  }
  return null;
};

export const getPointOfInterest = (state) => {
  const data = state.cms.poi.poi;
  if (data) {
    return data;
  }
  return null;
};

export const getRegion = (state) => {
  const data = state.cms.region.region;
  if (data) {
    return data;
  }
  return null;
};

export const getPage = (state, page) => {
  const data = state.cms.pages.pages[page];
  if (data) {
    return data;
  }
  return null;
};

export const getNearbyRegion = (state) => {
  const data = state.cms.nearbyRegion.nearbyRegion;
  if (data) {
    return data;
  }
  return null;
};



// WEBPACK FOOTER //
// ./src/selectors/cms.js